import Vue from "vue";
import VueI18n from "vue-i18n";
import en from '@/lang/en.js';
import zh from '@/lang/zh.js';
 
Vue.use(VueI18n); // 全局挂载


 
 
export const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || 'zh_CN' , // 从localStorage中获取 获取浏览器的语言
  messages: {
        'en_US':en, 
        'zh_CN':zh 
  }
});
 
export default i18n;